import { useCallback } from "react";

import { Button } from "@/components/ui/button/button";

type Props = {
	onClickCallback: () => void;
};

export const BlankButton = ({ onClickCallback }: Props) => {
	const handleClick = useCallback(() => {
		onClickCallback();
	}, [onClickCallback]);

	return (
		<Button variant="outline" type="button" size="sm" className="shrink-0 whitespace-nowrap" onClick={handleClick}>
			ブランクにする
		</Button>
	);
};
